import * as loadedConfig from "!val-loader!./config-loader.js"

export interface IConfig {
  env: "production" | "development" | "test" | "local" | "stage";
  appUrl: string;
  apiUrl: string;
  functionsUrl: string;
}

export const config = loadedConfig as IConfig;
export default config;
